import enviro from 'enviro';
import { getHasAcceptanceTestOverride } from './commMethodOverrides';
export const getIsProdAcceptanceTest = () => {
  const isProd = enviro.isProd();
  return isProd && getHasAcceptanceTestOverride();
};